/** @jsx jsx */
import { css, jsx } from "@emotion/core";

const Button = ({ hidden, setHidden, btnText }) => (
  <button className="btn" onClick={() => setHidden(hidden)} css={styles}>
    {btnText}
  </button>
);

const styles = css`
  border: none;
  outline: none;
  background: #4e5369;
  color: #fff;
  width: 100px;
  padding: 10px;
  margin-left: 14px;
  cursor: pointer;
  transition: background 400ms ease-in-out;
  &:hover {
    background: #3a3e4c;
  }
`;

export default Button;
